/**
 * Reconnexion SANS quitter la page : la connexion s'ouvre dans un nouvel onglet, la page en cours
 * (dossier, modal IA) reste en place. Le nouvel onglet écrit `token` / `token_expires_at` dans le
 * localStorage, partagé entre onglets : `watchSessionRenewal` le voit à l'onglet d'origine.
 */
const REAUTH_PARAM = 'reauth';

/** `/login?reauth=1` s'affiche même avec un jeton en place (voir GuestRoute). */
export const isReauthRequest = (search: string): boolean => new URLSearchParams(search).has(REAUTH_PARAM);

export function openReauthLogin(): void {
    window.open(`${WP_BASE_HREF}/login?${REAUTH_PARAM}=1`, '_blank', 'noopener');
}

const sessionSnapshot = (): string =>
    `${localStorage.getItem('token') ?? ''}|${localStorage.getItem('token_expires_at') ?? ''}`;

/** Prévient UNE fois qu'une connexion faite ailleurs a renouvelé la session (nouveau jeton ou
 *  nouvelle échéance) : à l'event `storage`, ou au retour sur l'onglet. Rend le désabonnement. */
export function watchSessionRenewal(onRenewed: () => void): () => void {
    const before = sessionSnapshot();
    const check = (): void => {
        if (!localStorage.getItem('token') || sessionSnapshot() === before) return;
        stop();
        onRenewed();
    };
    const stop = (): void => {
        window.removeEventListener('storage', check);
        window.removeEventListener('focus', check);
    };
    window.addEventListener('storage', check);
    window.addEventListener('focus', check);
    return stop;
}
